<template>
	<colla class="collapp-li" transition="slide">
      <colla class="collapp-profile"><img :src="avatar" alt=""></colla>
      <colla class="collapp-msg">
        <colla class="collapp-msg-body">
          <p class="collapp-name">{{ comment.name }} <colla class="collapp-date">{{ time }}</colla></p>
          <p v-html="comment.message"></p>
        </colla>
      </colla>
    </colla>
</template>

<script>
export default {

	props: ['comment'],

	computed: {
		avatar: function () {
            return 'https://api.adorable.io/avatars/48/' + this.comment.name.toString().toLowerCase().trim().replace(/[\s\W-]+/g, '-')  + '@adorable.io.png'
		},

		time: function () {

            var today = new Date();

            const endDate = new Date(this.comment.time);
            const days = parseInt((endDate - today) / (1000 * 60 * 60 * 24));
            const hours = parseInt(Math.abs(endDate - today) / (1000 * 60 * 60) % 24);
            const minutes = parseInt(Math.abs(endDate.getTime() - today.getTime()) / (1000 * 60) % 60);
            const seconds = parseInt(Math.abs(endDate.getTime() - today.getTime()) / (1000) % 60);

            //console.log('######');
            //console.log('days ' + days);
            //console.log('hours ' + hours);
            //console.log('minutes ' + minutes);
            //console.log('seconds ' + seconds);

            // return now
            if(days == 0 && hours == 0 && minutes < 1)
                return 'now';

            if(days == 0 && hours == 0)
                return minutes + 'm';

            if(days == 0 && hours > 0)
                return hours + 'h' + minutes + 'm';

            if(days < 0)
                return Math.abs(days) + 'd';


            return '-';
	    }
    }
}
</script>


// WEBPACK FOOTER //
// Comment.vue?35f88a06